import { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import moment from 'moment';

import { useClearTasks } from '../..';
import { IMAGE_MAPPER_BY_TASK_TYPE } from '../../../../helper/imageFileResolver';
import {
  actions as tasksActions,
  selectors as tasksSelectors,
} from '../../../../store/tasks';

const useUpdateTask = () => {
  const updateTaskIsFetching = useSelector(
    tasksSelectors.selectUpdateTaskIsFetching,
  );

  const updateTaskSuccess = useSelector(tasksSelectors.selectUpdateTaskSuccess);

  const redirectTask = useSelector(tasksSelectors.selectTaskRedirect);

  const updateTaskError = useSelector(tasksSelectors.selectUpdateTaskError);

  const dispatch = useDispatch();

  const updateTask = useCallback(
    (id, values) => {
      const { id: skip, ...data } =
        IMAGE_MAPPER_BY_TASK_TYPE[values.type](values);
      data.updatedAt = moment().toISOString(true);
      dispatch(tasksActions.updateTaskRequest(id, data));
    },
    [dispatch],
  );

  const redirectTaskSuccess = useCallback(() => {
    dispatch(tasksActions.redirectTaskSuccess());
  }, [dispatch]);

  const clearTasks = useClearTasks();

  useEffect(() => {
    clearTasks();
  }, [clearTasks]);

  return {
    updateTask,
    updateTaskIsFetching,
    updateTaskSuccess,
    updateTaskError,
    redirectTask,
    redirectTaskSuccess,
    clearTasks,
  };
};

export default useUpdateTask;
